import React from 'react'
import ContentArea from '../components/content-area/Content'
import BoothPng from "../assets/icons/booth.png";
import BoothGrid from '../components/booth/BoothGrid'

const Booth = () => (
  <ContentArea title="Booths" icon={BoothPng}>
    <BoothGrid />
  </ContentArea>
)

export default Booth
